export default __webpack_public_path__ + "static/Portfolio-3576bee0124761ea5ce2c6d604e85e44.png";